import React from 'react'

const Home = () => {
  return (
    <div>1</div>
  )
}

export default Home
